module.exports = __webpack_public_path__ + "static/media/CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz.6226d753.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL12_1dZS-vgDc7bdqE7ewY2V4QaLZ0qJN30Xz
// module id = 773
// module chunks = 0